// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sub-footer {
  font-family: "Proxima Nova", sans-serif;
  display: flex;
  flex-direction: column;
  position: relative;
  justify-content: space-between;
  min-height: auto;
  height: 150px;
  background: white;
  padding: 0;
  margin: 0;
  box-shadow: none;
}
.sub-footer ul {
  padding: 0 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 65px;
}
.sub-footer ul li {
  margin-right: 50px;
  color: var(--secondary-color-3) !important;
  font-size: 15px;
  transition: 0.3s ease-in-out;
}
.sub-footer ul li:hover {
  opacity: 0.75;
}
.sub-footer ul li:last-child {
  margin-right: 0;
}
.sub-footer div.sub-footer--inner {
  padding: 0 50px;
  height: 85px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--secondary-color-4);
}
.sub-footer div.sub-footer--inner .sub-footer--icon-container {
  flex: 1 1;
}
.sub-footer div.sub-footer--inner .sub-footer--icon-container > svg {
  margin-left: 10px;
  align-content: center;
}
.sub-footer div.sub-footer--inner .sub-footer--logo {
  flex: 1 1;
  text-align: center;
}
.sub-footer div.sub-footer--inner .copy-term {
  flex: 1 1;
  color: var(--secondary-color-3);
  padding-right: -180px;
  font-size: 12px;
  text-align: right;
  font-weight: 700;
}
.sub-footer div.sub-footer--inner .copy-term span:first-child {
  padding-right: 50px;
}
.sub-footer .footer--items {
  justify-content: center;
  margin-top: 113px;
  display: flex;
}
.sub-footer .footer--item {
  text-align: center;
  font-size: 16px;
}
.sub-footer .footer--item > ul > li {
  padding-bottom: 12px;
  font-weight: 700;
}
.sub-footer .footer--item .item--header {
  font-size: 20px;
  padding-bottom: 24px;
  font-weight: 300;
}
.sub-footer .footer--footnote {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  margin-bottom: 37px;
}
.sub-footer .footer--footnote .showingbee-logo {
  position: absolute;
  right: 50%;
  transform: translateX(50%);
}
.sub-footer .terms,
.sub-footer .copyright {
  font-size: 15px;
  color: #fff;
  opacity: 0.6;
}
.sub-footer .social-icons {
  position: absolute;
  bottom: 60px;
  right: 0;
}
.sub-footer .social-icons > svg {
  margin-left: 22px;
}
.sub-footer .footer--search {
  position: relative;
  padding: 0 110px;
}
.sub-footer .footer--search > div {
  position: absolute;
  justify-content: space-between;
  width: 100%;
  padding: 35px;
  background: #2A2A2A;
  border-radius: 10px;
  right: 0;
  margin-top: -75px;
}
.sub-footer .footer--search > div .search-text > p {
  font-size: 25px;
  color: #fff;
}

@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .sub-footer {
    height: 100%;
    margin-top: 50px;
  }
  .sub-footer ul {
    padding: 0 10px;
    flex-wrap: wrap;
  }
  .sub-footer ul li {
    margin: 0 10px;
    text-align: center;
    font-size: 10px;
  }
  .sub-footer div.sub-footer--inner {
    padding: 50px 0;
    height: 250px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    background: var(--secondary-color-4);
  }
  .sub-footer div.sub-footer--inner .sub-footer--icon-container {
    flex: 1 1;
  }
  .sub-footer div.sub-footer--inner .sub-footer--icon-container > svg {
    margin-left: 10px;
    align-content: center;
  }
  .sub-footer div.sub-footer--inner .sub-footer--logo {
    flex: 1 1;
    text-align: center;
  }
  .sub-footer div.sub-footer--inner .copy-term {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
  }
  .sub-footer div.sub-footer--inner .copy-term span:first-child {
    padding-right: 0px;
  }
}
@media (min-width: 768px) and (max-width: 1024px), (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .sub-footer {
    height: 100%;
    margin-top: 50px;
  }
  .sub-footer ul {
    padding: 0 10px;
    flex-wrap: wrap;
  }
  .sub-footer ul li {
    margin: 0 10px;
    text-align: center;
    font-size: 10px;
  }
  .sub-footer div.sub-footer--inner {
    padding: 50px 0;
    height: 250px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    background: var(--secondary-color-4);
  }
  .sub-footer div.sub-footer--inner .sub-footer--icon-container {
    flex: 1 1;
  }
  .sub-footer div.sub-footer--inner .sub-footer--icon-container > svg {
    margin-left: 10px;
    align-content: center;
  }
  .sub-footer div.sub-footer--inner .sub-footer--logo {
    flex: 1 1;
    text-align: center;
  }
  .sub-footer div.sub-footer--inner .copy-term {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
  }
  .sub-footer div.sub-footer--inner .copy-term span:first-child {
    padding-right: 0px;
  }
}
@media (width: 1024px) and (max-height: 833px) {
  .sub-footer {
    height: 100%;
    margin-top: 50px;
  }
  .sub-footer ul {
    padding: 0 10px;
    flex-wrap: wrap;
  }
  .sub-footer ul li {
    margin: 0 10px;
    text-align: center;
    font-size: 10px;
  }
  .sub-footer div.sub-footer--inner {
    padding: 50px 0;
    height: 250px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    background: var(--secondary-color-4);
  }
  .sub-footer div.sub-footer--inner .sub-footer--icon-container {
    flex: 1 1;
  }
  .sub-footer div.sub-footer--inner .sub-footer--icon-container > svg {
    margin-left: 10px;
    align-content: center;
  }
  .sub-footer div.sub-footer--inner .sub-footer--logo {
    flex: 1 1;
    text-align: center;
  }
  .sub-footer div.sub-footer--inner .copy-term {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
  }
  .sub-footer div.sub-footer--inner .copy-term span:first-child {
    padding-right: 0px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Footer/subfooter.scss","webpack://./src/assets/styles/_mixins.scss"],"names":[],"mappings":"AAEA;EACI,uCAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,8BAAA;EAEA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;AAFJ;AAII;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AAFR;AAIQ;EACI,kBAAA;EACA,0CAAA;EACA,eAAA;EACA,4BAAA;AAFZ;AAIY;EACI,aAAA;AAFhB;AAKY;EACI,eAAA;AAHhB;AAQI;EACI,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,oCAAA;AANR;AAQQ;EACI,SAAA;AANZ;AAQY;EACI,iBAAA;EACA,qBAAA;AANhB;AAUQ;EACI,SAAA;EACA,kBAAA;AARZ;AAWQ;EACI,SAAA;EACA,+BAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AATZ;AAWY;EACI,mBAAA;AAThB;AAcI;EACI,uBAAA;EACA,iBAAA;EACA,aAAA;AAZR;AAeI;EACI,kBAAA;EACA,eAAA;AAbR;AAgBI;EACI,oBAAA;EACA,gBAAA;AAdR;AAiBI;EACI,eAAA;EACA,oBAAA;EACA,gBAAA;AAfR;AAkBI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,mBAAA;AAhBR;AAkBQ;EACI,kBAAA;EACA,UAAA;EACA,0BAAA;AAhBZ;AAoBI;;EAEI,eAAA;EACA,WAAA;EACA,YAAA;AAlBR;AAqBI;EACI,kBAAA;EACA,YAAA;EACA,QAAA;AAnBR;AAqBQ;EACI,iBAAA;AAnBZ;AAuBI;EACI,kBAAA;EACA,gBAAA;AArBR;AAuBQ;EACI,kBAAA;EACA,8BAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;AArBZ;AAuBY;EACI,eAAA;EACA,WAAA;AArBhB;;ACxHY;EDuJR;IACI,YAAA;IACA,gBAAA;EA3BN;EA6BM;IACI,eAAA;IACA,eAAA;EA3BV;EA6BU;IACI,cAAA;IACA,kBAAA;IACA,eAAA;EA3Bd;EA+BM;IACI,eAAA;IACA,aAAA;IACA,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,8BAAA;IACA,oCAAA;EA7BV;EA+BU;IACI,SAAA;EA7Bd;EA+Bc;IACI,iBAAA;IACA,qBAAA;EA7BlB;EAiCU;IACI,SAAA;IACA,kBAAA;EA/Bd;EAkCU;IACI,SAAA;IACA,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,yBAAA;EAhCd;EAkCc;IACI,kBAAA;EAhClB;AACF;AC/JY;EDgJR;IACI,YAAA;IACA,gBAAA;EAkBN;EAhBM;IACI,eAAA;IACA,eAAA;EAkBV;EAhBU;IACI,cAAA;IACA,kBAAA;IACA,eAAA;EAkBd;EAdM;IACI,eAAA;IACA,aAAA;IACA,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,8BAAA;IACA,oCAAA;EAgBV;EAdU;IACI,SAAA;EAgBd;EAdc;IACI,iBAAA;IACA,qBAAA;EAgBlB;EAZU;IACI,SAAA;IACA,kBAAA;EAcd;EAXU;IACI,SAAA;IACA,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,yBAAA;EAad;EAXc;IACI,kBAAA;EAalB;AACF;ACrMY;EDyIR;IACI,YAAA;IACA,gBAAA;EA+DN;EA7DM;IACI,eAAA;IACA,eAAA;EA+DV;EA7DU;IACI,cAAA;IACA,kBAAA;IACA,eAAA;EA+Dd;EA3DM;IACI,eAAA;IACA,aAAA;IACA,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,8BAAA;IACA,oCAAA;EA6DV;EA3DU;IACI,SAAA;EA6Dd;EA3Dc;IACI,iBAAA;IACA,qBAAA;EA6DlB;EAzDU;IACI,SAAA;IACA,kBAAA;EA2Dd;EAxDU;IACI,SAAA;IACA,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,yBAAA;EA0Dd;EAxDc;IACI,kBAAA;EA0DlB;AACF","sourcesContent":["@import 'assets/styles/_mixins.scss';\n\n.sub-footer {\n    font-family: 'Proxima Nova', sans-serif;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    justify-content: space-between;\n\n    min-height: auto;\n    height: 150px;\n    background: white;\n    padding: 0;\n    margin: 0;\n    box-shadow: none;\n\n    ul {\n        padding: 0 100px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        height: 65px;\n\n        li {\n            margin-right: 50px;\n            color: var(--secondary-color-3) !important;\n            font-size: 15px;\n            transition: .3s ease-in-out;\n\n            &:hover {\n                opacity: .75;\n            }\n\n            &:last-child {\n                margin-right: 0;\n            }\n        }\n    }\n\n    div.sub-footer--inner {\n        padding: 0 50px;\n        height: 85px;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        background: var(--secondary-color-4);\n\n        .sub-footer--icon-container {\n            flex: 1;\n\n            >svg {\n                margin-left: 10px;\n                align-content: center;\n            }\n        }\n\n        .sub-footer--logo {\n            flex: 1;\n            text-align: center;\n        }\n\n        .copy-term {\n            flex: 1;\n            color: var(--secondary-color-3);\n            padding-right: -180px;\n            font-size: 12px;\n            text-align: right;\n            font-weight: 700;\n\n            span:first-child {\n                padding-right: 50px;\n            }\n        }\n    }\n\n    .footer--items {\n        justify-content: center;\n        margin-top: 113px;\n        display: flex;\n    }\n\n    .footer--item {\n        text-align: center;\n        font-size: 16px;\n    }\n\n    .footer--item>ul>li {\n        padding-bottom: 12px;\n        font-weight: 700;\n    }\n\n    .footer--item .item--header {\n        font-size: 20px;\n        padding-bottom: 24px;\n        font-weight: 300;\n    }\n\n    .footer--footnote {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        position: relative;\n        margin-bottom: 37px;\n\n        .showingbee-logo {\n            position: absolute;\n            right: 50%;\n            transform: translateX(50%);\n        }\n    }\n\n    .terms,\n    .copyright {\n        font-size: 15px;\n        color: #fff;\n        opacity: .6;\n    }\n\n    .social-icons {\n        position: absolute;\n        bottom: 60px;\n        right: 0;\n\n        &>svg {\n            margin-left: 22px;\n        }\n    }\n\n    .footer--search {\n        position: relative;\n        padding: 0 110px;\n\n        >div {\n            position: absolute;\n            justify-content: space-between;\n            width: 100%;\n            padding: 35px;\n            background: #2A2A2A;\n            border-radius: 10px;\n            right: 0;\n            margin-top: -75px;\n\n            .search-text>p {\n                font-size: 25px;\n                color: #fff;\n            }\n        }\n    }\n}\n\n\n@include media(mobile, tablet, nitty-gritt) {}\n\n@include media(mobile, tablet, nitty-gritt) {\n    .sub-footer {\n        height: 100%;\n        margin-top: 50px;\n\n        ul {\n            padding: 0 10px;\n            flex-wrap: wrap;\n\n            li {\n                margin: 0 10px;\n                text-align: center;\n                font-size: 10px;\n            }\n        }\n\n        div.sub-footer--inner {\n            padding: 50px 0;\n            height: 250px;\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            justify-content: space-between;\n            background: var(--secondary-color-4);\n\n            .sub-footer--icon-container {\n                flex: 1;\n\n                >svg {\n                    margin-left: 10px;\n                    align-content: center;\n                }\n            }\n\n            .sub-footer--logo {\n                flex: 1;\n                text-align: center;\n            }\n\n            .copy-term {\n                flex: 1;\n                display: flex;\n                flex-direction: column;\n                align-items: center;\n                justify-content: flex-end;\n\n                span:first-child {\n                    padding-right: 0px;\n                }\n            }\n        }\n    }\n}","@mixin media($keys...) {\r\n    @each $key in $keys {\r\n        @if ($key==mobile) {\r\n            @media (min-width: 481px) and (max-width: 767px),\r\n            (min-width: 320px) and (max-width: 480px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==tablet) {\r\n            @media (min-width: 768px) and (max-width: 1024px),\r\n            (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==nitty-gritt) {\r\n            @media (width: 1024px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==small-desktop) {\r\n            @media (max-width: 1440px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==desktop) {\r\n            @media (min-width: 1024px) and (max-width: 1440px) {\r\n                @content;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
